export default __webpack_public_path__ + "static/media/step3-section3.a99386c5.png";